import { createSlice } from '@reduxjs/toolkit';
import { dummyWriteOffData } from '../../constants/InverntoryConstants';

const initialState = {
  writeOffData: dummyWriteOffData,
  loading: false,
  error: null,
};

const writeOffSlice = createSlice({
  name: 'writeOff',
  initialState,
  reducers: {
    addWriteOff: (state, action) => {
      const newWriteOff = {
        id: state.writeOffData.length + 1,
        ...action.payload,
        status: "Pending",
        createdAt: new Date().toLocaleDateString()
      };
      state.writeOffData.push(newWriteOff);
    },
    updateWriteOff: (state, action) => {
      const index = state.writeOffData.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.writeOffData[index] = { ...state.writeOffData[index], ...action.payload };
      }
    },
    deleteWriteOff: (state, action) => {
      state.writeOffData = state.writeOffData.filter(item => item.id !== action.payload);
    },
    setWriteOffData: (state, action) => {
      state.writeOffData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const {
  addWriteOff,
  updateWriteOff,
  deleteWriteOff,
  setWriteOffData,
  setLoading,
  setError,
  clearError
} = writeOffSlice.actions;

export default writeOffSlice.reducer;